KXL.module('Common.Views', function (Views, KXL, Backbone, Marionette, $, _) {
	Views.ContentWithNav = Marionette.Layout.extend({
		template: '#content-with-nav',
		regions: {
			navRegion: '.content-nav-region',
			contentRegion: '.content-region'
		}
	});
});